import { Box, Button, CircularProgress, Grid } from '@mui/material';
import { Form, Formik } from 'formik';
import React, { memo, useState } from 'react';
import Textfield from '../../components/input/Textfield';
import * as Yup from 'yup';
import { apiRequest } from '../../utils/api';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchProductData } from '../../redux/slices/productSlice';
import SelectWrapper from '../../components/input/Select';
import { productCategories, productSubCategories } from '../../assets/data';

const Edit = ({ onClose, product }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const FORM_VALIDATION = Yup.object().shape({
        name: Yup.string().trim().required('Required'),
        price: Yup.string().trim(),
        // quantity: Yup.number().typeError('Quantity must be a number').required('Required'),
        packing: Yup.string().trim(),
        category: Yup.string().trim().required('Required'),
        // subCategory: Yup.string().trim().required('Required')
    });

    const handleSubmit = async (values) => {
        try {
            const resp = await apiRequest('put', `products/${product?.id}`, values);

            if (resp?.data) {
                onClose();
                dispatch(fetchProductData());
            }
        } catch (error) {
            return toast.error(error?.response?.data?.message ?? error?.response?.data ?? error?.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    category: '',
                    // subCategory: '',
                    ...product
                }}
                validationSchema={FORM_VALIDATION}
                onSubmit={(values, { resetForm }) => {
                    setLoading(true);
                    handleSubmit(values, resetForm);
                }}
            >
                {({ values, setFieldValue }) => (
                    <Form>
                        <Grid container direction="row" spacing={2}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                                <Textfield name="name" label="Name" />
                            </Grid>

                            <Grid item lg={6} md={6} sm={6} xs={12}>
                                <Textfield name="packing" label="Packing" />
                            </Grid>

                            <Grid item lg={6} md={6} sm={6} xs={12}>
                                <Textfield name="price" label="Price" />
                            </Grid>

                            <Grid item lg={6} md={6} sm={6} xs={12}>
                                <SelectWrapper
                                    defaultValue=""
                                    name="category"
                                    // onChange={() => setFieldValue('subCategory', null)}
                                    label={'Category'}
                                    options={productCategories}
                                />
                            </Grid>

                            {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                                <SelectWrapper
                                    defaultValue=""
                                    name="subCategory"
                                    label={'Sub Category'}
                                    options={productSubCategories[values?.category] || []}
                                />
                            </Grid> */}

                            {/* <Grid item lg={6} md={6} sm={6} xs={12}>
                            <Textfield type="number" name="quantity" label="Quantity" />
                        </Grid> */}
                        </Grid>

                        <Box sx={styles.btnContainer}>
                            {loading ? (
                                <CircularProgress size={25} color="inherit" />
                            ) : (
                                <>
                                    {/* -------------- onClick will call the onClose function that closes the History Modal */}
                                    <Button onClick={onClose} variant="text" sx={{ color: 'red' }}>
                                        Cancel
                                    </Button>

                                    {/* -----------  change button title on the basis of history status */}
                                    <Button type="submit" variant="text">
                                        Update
                                    </Button>
                                </>
                            )}
                        </Box>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default memo(Edit);

const styles = {
    loadingContainer: {
        height: 400,
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    btnContainer: {
        display: 'flex',
        direction: 'row',
        gap: 1,
        marginTop: 1,
        justifyContent: 'flex-end'
    }
};
